<template>
  <!-- 技术方案编写 -->
  <div class="technical_proposal">
    <div class="technical_first">
      <div class="technical_name">
        <span v-if="dataObject.modleType === 'JSFA'">技术方案编写</span
        ><span v-if="dataObject.modleType === 'JSFAXG'">技术方案修改</span>
      </div>
      <div :class="'technical technical_' + dataObject.synergeticState">
        {{ judgmentStatus(dataObject.synergeticState) }}
      </div>
    </div>
    <div style="padding-left: 5px">
      <el-form label-width="100px" label-position="left">
        <el-form-item label="招标意向：">
          <div>{{ dataObject.throwOrgFAVO.throwProjectName }}</div>
        </el-form-item>
        <el-form-item label="招标信息：">
          <div
            style="color: blue; text-decoration: underline; cursor: pointer"
            @click="openDetails"
          >
            查看招标信息详情
          </div>
        </el-form-item>
        <el-form-item label="任务接收人：">
          <div>
            <span
              v-for="(item, index) in dataObject.boxEmplList"
              style="margin-right: 6px"
              :key="index"
              >{{ item.trueName }}</span
            >
            <el-button
              type="warning"
              size="mini"
              v-if="dataObject.synergeticState !== 'YWC'"
              @click="increaseRecipient"
              >添加接收人</el-button
            >
          </div>
        </el-form-item>
        <el-form-item label="任务截至时间：" label-width="110px">
          <div>{{ dataObject.jobOverDate }}</div>
        </el-form-item>
        <el-form-item
          label="备注："
          label-width="110px"
          v-show="dataObject.throwOrgFAVO.description"
        >
          <div>{{ dataObject.throwOrgFAVO.description }}</div>
        </el-form-item>
        <el-form-item
          label="修改要求:"
          label-width="110px"
          v-show="dataObject.jobDesc"
        >
          <div>{{ dataObject.jobDesc }}</div>
        </el-form-item>
        <el-form-item label="技术方案：">
          <JYOssUploadFiles
            :file-list="attachs"
            :limit="1"
            :statusIsEdit="dataObject.synergeticState == 'YWC'"
            :accept="'.doc,.docx,.pdf,.xlsx,.xls,.png,.jpg,.jpeg'"
          />
        </el-form-item>
        <div
          style="text-align: center; margin-top: 20px"
          v-if="dataObject.synergeticState !== 'YWC'"
        >
          <el-button type="primary" @click="compilationCompleted"
            >确认完成</el-button
          >
        </div>
        <el-divider></el-divider>
        <div v-if="dataObject.throwOrgFAVO.approveId">
          <div class="modleType_jj" v-if="dataObject.modleType === 'JSFAXG'">
            上一版本技术方案审批拒接意见
          </div>
          <JySingleApproval :approval-id="dataObject.throwOrgFAVO.approveId">
          </JySingleApproval>
        </div>
      </el-form>
    </div>
    <!-- 添加接收人 -->
    <el-dialog
      title="添加接收人"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form
        ref="recipientForm"
        :model="recipientForm"
        :rules="recipientRules"
        label-position="left"
        label-width="140px"
        class="demo-ruleForm"
      >
        <el-form-item label="接收人：" prop="employeeId">
          <el-select
            v-model="recipientForm.employeeId"
            filterable
            clearable
            placeholder="请选择接收人"
            style="width: 100%"
          >
            <el-option
              v-for="item in personnelList"
              :key="item.employeeId"
              :label="item.trueName"
              :value="item.employeeId + ',' + item.trueName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div style="text-align: center; margin-top: 20px">
          <el-button type="primary" @click="submit('recipientForm')"
            >提交</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <!-- 招标信息详情 -->
    <el-dialog
      title="招标信息详情"
      :visible.sync="biddingInformationDialog"
      width="50%"
      :before-close="biddingInformationClose"
    >
      <el-row :gutter="20" class="bid-manage-card">
        <el-col :span="24">
          <b>招标意向标题：</b><span>{{ form.throwProjectName }}</span>
        </el-col>
        <el-col :span="24">
          <b>信息来源：</b>
          <span>
            {{
              form.infoFrom == "GGZYJYPT" ? "公共资源交易平台" : "内部资源"
            }},{{ form.infoFromText }}
          </span>
        </el-col>
        <el-col :span="6">
          <b>业务类型：</b>
          <span>
            {{ form.projectTypeSubName }}
          </span>
        </el-col>
        <el-col :span="6">
          <b>招标类型：</b>
          <span>
            {{
              throwTypeOptions.find((it) => it.throwTypeId == form.throwTypeId)
                ? throwTypeOptions.find(
                    (it) => it.throwTypeId == form.throwTypeId
                  ).throwTypeName
                : ""
            }}
          </span>
        </el-col>
        <el-col :span="12">
          <b>投标时间：</b>
          <span> {{ form.startDate + " ~ " + form.endDate }}</span>
        </el-col>
        <el-col :span="24">
          <b>招标人信息：</b>
          <el-card shadow="never">
            <el-row :gutter="30">
              <el-col :span="24">
                <b>招标人：</b>
                <span> {{ form.thrPeople }}</span>
              </el-col>
              <el-col :span="7">
                <b>联系人：</b>
                <span> {{ form.thrProxy }}</span>
              </el-col>
              <el-col :span="7">
                <b>联系电话：</b>
                <span> {{ form.thrProxyMobile }}</span>
              </el-col>
              <el-col :span="10">
                <b>电子邮件：</b>
                <span> {{ form.thrProxyEmail }}</span>
              </el-col>
              <el-col :span="24">
                <b>地址：</b>
                <span> {{ form.thrPeopleAddr }}</span>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="24">
          <b>招标代理机构信息：</b>
          <el-card shadow="never">
            <el-row :gutter="30">
              <el-col :span="24">
                <b>招标代理公司：</b>
                <span> {{ form.thrCompany }}</span>
              </el-col>
              <el-col :span="7">
                <b>联系人：</b>
                <span> {{ form.thrCompanyProxy }}</span>
              </el-col>
              <el-col :span="7">
                <b>联系电话：</b>
                <span> {{ form.thrCompanyProxyMobile }}</span>
              </el-col>
              <el-col :span="10">
                <b>电子邮件：</b>
                <span> {{ form.thrCompanyProxyEmail }}</span>
              </el-col>
              <el-col :span="24">
                <b>地址：</b>
                <span> {{ form.thrCompanyAddr }}</span>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="24">
          <b>招标范围及项目基本情况：</b>
          <p>{{ form.thrProjectInfo }}</p>
        </el-col>
        <el-col :span="24">
          <b>招标条件：</b>
          <p>{{ form.thrCondition }}</p>
        </el-col>
        <el-col :span="24">
          <b>投标要求及时间：</b>
          <p>{{ form.bidCondition }}</p>
        </el-col>
        <el-col :span="24">
          <b>备注说明：</b>
          <p>{{ form.commentDesc }}</p>
        </el-col>
        <el-col :span="24">
          <b>其他附件：</b>
          <p>
            <el-button
              type="text"
              v-for="item in form.throwFilePos"
              :key="item.filePath"
              @click.native="showFile(item.filePath)"
              style="text-decoration: underline"
              >{{ item.fileName }}</el-button
            >
          </p>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { ossShowFile, ossDownLoad, } from '@jy/utils/ossuploadfile'
import { addBoxEmpl, addFinish, projectInfo, throwType } from '@/api/bidBox'
import BoxFileList from '@/components/uploadfiel/boxFileList'
import { fileUpload } from '@/api/publiccommon'
export default {
  name: 'BidTaskBoxCollection',
  computed: {

  },
  components: {
    BoxFileList
  },
  props: {
    dataObject: {
      type: Object,
      default: {},
      required: true
    },
    personnelList: {
      type: Array,
      default: {},
      required: true
    },
    btnauth: {
      type: Array,
      default: {},
      required: true
    },
  },
  data () {
    return {
      dialogVisible: false,
      recipientForm: {
        employeeId: ''
      },//接收人 表单提交
      recipientRules: {
        employeeId: [
          { required: true, message: '请选择接收人', trigger: 'change' }
        ]
      },
      biddingInformationDialog: false,//招标信息 弹窗 显示隐藏
      form: {},
      throwTypeOptions: [],//招标类型
      attachs: [],//文件列表
    }
  },
  watch: {

  },
  created () {
    if (this.dataObject.throwOrgFAVO.fileName !== null && !(this.dataObject.modleType === 'JSFAXG' && this.dataObject.synergeticState == "DWC")) {
      let par = {
        fileName: this.dataObject.throwOrgFAVO.fileName,
        filePath: this.dataObject.throwOrgFAVO.filePath,
        fileSize: this.dataObject.throwOrgFAVO.fileSize,
        fileType: this.dataObject.throwOrgFAVO.fileType,
        businessType: this.dataObject.modleType,
        businessId: this.dataObject.boxId,
      }
      this.attachs.push(par)
    }
    this.getThrowType()
  },
  mounted () {

  },
  methods: {
    showFile (path) {
      ossShowFile(path)
    },
    // 打开 添加接收人 表单
    increaseRecipient () {
      this.dialogVisible = true
    },
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let arr = this.recipientForm.employeeId.split(',')
          let par = {
            boxId: this.dataObject.boxId,
            employeeId: arr[0],
            trueName: arr[1]
          }
          addBoxEmpl(par).then(res => {
            if (res.status === 200) {
              this.$message.success('接收人添加成功')
              this.recipientForm = {
                employeeId: ''
              }//接收人 表单提交
              this.$refs[formName].resetFields()
              this.$emit('renewList')
              this.dialogVisible = false
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 关闭接收人 表单
    handleClose () {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.dialogVisible = false
          this.$refs['recipientForm'].resetFields()
        })
        .catch(_ => { })
    },
    // 编写完成
    compilationCompleted () {
      console.log(this.attachs)
      if (this.attachs.length === 0) {
        return this.$message.warning('请上传技术方案')
      } else {
        this.attachs.forEach(item => {
          item.businessType = this.dataObject.modleType
          item.businessId = this.dataObject.boxId
        })
      }
      this.$confirm('此操作将确认完成, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let par = {
          throwFileEntities: this.attachs,
          boxId: this.dataObject.boxId,
          businessId: this.dataObject.boxId,
          modleType: this.dataObject.modleType,
          modleId: this.dataObject.modleId,
        }
        addFinish(par).then(res => {
          if (res.status === 200) {
            this.$message.success('已确认完成')
            this.$emit('renewList')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消确认完成'
        })
      })
    },
    // 打开招标详情 弹窗
    openDetails () {
      projectInfo(this.dataObject.throwOrgFAVO.throwProjectId).then(res => {
        if (res.status === 200) {
          this.form = res.data
          // this.form.startDate = new Date(this.form.startDate).format("yyyy-MM-dd hh:mm")
          // this.form.endDate = new Date(this.form.endDate).format("yyyy-MM-dd hh:mm")
          this.biddingInformationDialog = true
        }
      })
    },
    // 关闭 招标详情 弹窗
    biddingInformationClose () {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.biddingInformationDialog = false
        })
        .catch(_ => { })
    },
    //招标类型
    getThrowType () {
      throwType().then(res => {
        if (res.status == 200) {
          this.throwTypeOptions = res.data || []
        }
      })
    },
    // 判断状态
    judgmentStatus (type) {
      if (type === 'DWC') {
        return '待完成'
      } else if (type === 'YWC') {
        return '已完成'
      } else if (type === 'YZF') {
        return '已作废'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.technical_proposal {
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid #e90e36;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  .technical_first {
    display: flex;
    justify-content: space-between;
    .technical_name {
      margin-bottom: 20px;
      font-size: 16px;
      font-weight: 700;
    }
    .technical {
      height: 32px;
      padding: 0 10px;
      line-height: 30px;
      font-size: 12px;
      border-style: solid;
      border-radius: 4px;
      box-sizing: border-box;
      white-space: nowrap;
    }
    .technical_YWC {
      color: #026235;
      border: 1px solid #00f985;
      background: #b9e9d3;
    }
    .technical_DWC {
      color: #a10303;
      border: 1px solid #a10303;
      background: #f0a7a7;
    }
    .technical_YCH {
      color: #909399;
      border: 1px solid #909399;
      background: #f4f4f5;
    }
  }
}
::v-deep .el-form-item {
  margin-bottom: 0 !important;
}
.bid-manage-card {
  margin: 40px 60px !important;
  font-size: 14px;
  line-height: 28px;
  .el-col {
    margin: 10px 0 !important;
  }
  .el-card {
    margin: 10px 0;
  }
  span,
  p {
    font-size: 14px;
  }
  u {
    color: #409eff;
    cursor: pointer;
  }
}
.modleType_jj {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 20px;
}
::v-deep .text-ellipsis {
  max-width: 9vw;
}
</style>
